
export const Users = {
    LOADING_USERS_LIST: "LOADING_USERS_LIST",
    GET_USERS_LIST: "GET_USERS_LIST",
  };

